import React, { useState, useRef } from "react";
import { AvInput, AvGroup, AvFeedback } from "availity-reactstrap-validation";
import { Label, InputGroup, InputGroupAddon } from "reactstrap";

import eyeOpenIcon from "../../../assets/icons/eye-open.svg";
import eyeCloseIcon from "../../../assets/icons/eye-close.svg";
import { useTranslation } from "react-i18next";
import { inputTypeConstants } from "../../../constants";

const InputField = ({
  name = "password",
  placeholder,
  label,
  type,
  maxLength,
  pattern = "^[a-zA-Z0-9!@#$%^&*_=+-].{3,}$",
  validate,
  iconSize = { width: "20px", height: "20px" },
  className = "",
  id,
  errorMessage,
  patternErrorMessage = null,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation("common");
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const inputRef = useRef(null);

  const fieldId = id || name;

  return (
    <AvGroup className={`mb-0 ${className}`}>
      {label && (
        <Label for={fieldId} className="form-label label-content-600">
          {label}
        </Label>
      )}
      <InputGroup>
        <AvInput
          ref={inputRef}
          type={
            showPassword ? inputTypeConstants.TEXT : inputTypeConstants.PASSWORD
          }
          name={name}
          id={fieldId}
          placeholder={placeholder}
          maxLength={maxLength}
          validate={validate}
          pattern={pattern}
          className="form-control"
          {...otherProps}
        />
        <InputGroupAddon addonType="append">
          <button
            type="button"
            className="password-toggle-btn"
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <img
              src={showPassword ? eyeOpenIcon : eyeCloseIcon}
              alt={showPassword ? "Hide password" : "Show password"}
              style={iconSize}
            />
          </button>
        </InputGroupAddon>
      </InputGroup>{" "}
      <AvFeedback>
        {inputRef?.current?.value
          ? patternErrorMessage || t("invalid_field")
          : errorMessage}
      </AvFeedback>
    </AvGroup>
  );
};

export default InputField;
